export const NAV = [
  { id: "chi-sono", label: "Chi sono" },
  { id: "competenze", label: "Competenze" },
  { id: "approccio", label: "Approccio" },
  { id: "collaborare", label: "Collaborare" },
  { id: "contatti", label: "Contatti" },
];

export const COMPETENZE = [
  {
    n: "01",
    title: "Grafica pubblicitaria",
    desc: "La grafica è il primo linguaggio con cui un brand incontra le persone. Costruisco sistemi visivi coerenti, in cui composizione, tipografia e immagini lavorano insieme per rendere il messaggio riconoscibile e credibile. Ogni scelta grafica risponde a un'esigenza di comunicazione precisa: emergere nel giusto contesto, dire la cosa giusta, restare in mente.",
  },
  {
    n: "02",
    title: "Produzioni video",
    desc: "Il video è tempo, ritmo e sguardo. Curo la produzione come momento di sintesi tra idea e racconto: dalla direzione creativa alla scrittura per immagini, fino alle scelte di regia e montaggio. Racconto marchi, luoghi e persone con un linguaggio visivo che non impone, ma accompagna chi guarda dentro il tema.",
  },
  {
    n: "03",
    title: "Social media marketing",
    desc: "Sui social un brand esiste nella misura in cui riesce a essere coerente e riconoscibile nel tempo. Definisco l'identità dei contenuti, il tono di voce e la logica editoriale, mettendo insieme grafica, video e parole in un ritmo sostenibile. Non pubblicare per pubblicare: costruire una presenza che significhi qualcosa.",
  },
];

export const APPROCCIO = [
  {
    n: "01",
    title: "Comprendere",
    desc: "Prima delle idee, l'ascolto. Studio identità, contesto e obiettivi di chi ho di fronte: cosa vuole dire, a chi, e perché adesso.",
  },
  {
    n: "02",
    title: "Definire la direzione",
    desc: "Traduco l'ascolto in una direzione creativa chiara. Un'idea guida che orienta ogni scelta successiva — visiva, di contenuto, di canale.",
  },
  {
    n: "03",
    title: "Dare forma",
    desc: "Trasformo la direzione in linguaggi concreti: grafica, video, contenuti. È il momento in cui l'intuizione diventa materiale visibile.",
  },
  {
    n: "04",
    title: "Tenere insieme",
    desc: "Curo la coerenza tra i canali. Un brand comunica bene quando ogni tassello — un annuncio, un video, un post — parla la stessa lingua.",
  },
];

export const COLLABORAZIONI = [
  {
    title: "Direzione creativa complessiva",
    desc: "Una regia unica su tutta la comunicazione, coordinando linguaggi, contenuti e canali.",
  },
  {
    title: "Progetti di grafica pubblicitaria",
    desc: "Sistemi visivi, campagne stampa e digitali, materiali di marca.",
  },
  {
    title: "Produzioni video",
    desc: "Racconti per il brand, contenuti editoriali e formati per i social.",
  },
  {
    title: "Social media marketing",
    desc: "Impostazione dell'identità editoriale e cura continua della presenza online.",
  },
];

export const CONTACT = {
  email: "me@gianniragone.it",
  phone: "+39 345 9207366",
  phoneHref: "+393459207366",
  socials: [
    { label: "LinkedIn", href: "https://www.linkedin.com/in/gianni-ragone/", icon: "Linkedin" },
    { label: "Instagram", href: "https://www.instagram.com/gianniragone.studio/", icon: "Instagram" },
    { label: "Facebook", href: "https://www.facebook.com/gianni.ragone/", icon: "Facebook" },
  ],
};
